import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})

export class AppHeaderComponent implements OnInit {
  userProfile: object;

  logoLink: string;
  fdMagLink: string;
  baseLink: string;
  sif1Link: string;
  cambiaPasswordLink: string;
  constructor() {
    if (this.isProduzione()) {
      this.logoLink = 'https://www.fondirigenti.it';
      this.fdMagLink = 'https://fdmag.fondirigenti.it';
      this.baseLink = 'https://www.fondirigenti.it';
      this.sif1Link = 'http://aplfo.fondirigenti.it/default.do';
    } else {
      this.logoLink = 'https://liferay.coll.fondirigenti.it/c/portal/login';
      this.fdMagLink = 'https://fdmag.coll.fondirigenti.it';
      this.baseLink = 'https://liferay.coll.fondirigenti.it';
      this.sif1Link = 'http://aplfo.fondirigenti.it/login/helpLogin.do';
      this.cambiaPasswordLink = 'http://aplfo.fondirigenti.it/richiestaPassword.do';

    }
  }

  ngOnInit() {
    $(document).ready(() => {
      $('#culturaManag').mouseover(() => {
        $('#culturaManagMega').show();
        $('#serviziMenuMega').hide();
      });

      $('#serviziMenu').mouseover(() => {
        $('#serviziMenuMega').show();
        $('#culturaManagMega').hide();
      });

      $('#culturaManagMega').mouseout(() => {
        $('#culturaManagMega').hide();
      });

      $('#serviziMenuMega').mouseout(() => {
        $('#serviziMenuMega').hide();
      });

      $('#identitaMenu, #aderireMenu, #contattiMenu').mouseover(() => {
        $('#serviziMenuMega').hide();
        $('#culturaManagMega').hide();
      });

      $('.subMenu').hide();
      $('.frecciaDropmenu').click(() => {
        if ($('.subMenu').css('display') === 'none') {
          $('.subMenu').show();
          $('.frecciaDropmenu').removeClass('fa-chevron-down');
          $('.frecciaDropmenu').addClass('fa-chevron-up');
        } else {
          $('.subMenu').hide();
          $('.frecciaDropmenu').addClass('fa-chevron-down');
          $('.frecciaDropmenu').removeClass('fa-chevron-up');
        }
      });
    });
  }

  /* private configureCodeFlow() {
    this.authService.configure(authCodeFlowConfig);
    this.authService.tokenValidationHandler = new JwksValidationHandler();
    this.authService.loadDiscoveryDocumentAndTryLogin();
    // Optional
    // this.oauthService.setupAutomaticSilentRefresh();
  }
  */

  isUserLogged(): boolean | string {
    const accessUser = localStorage.getItem('access_user');
    if (accessUser == null) {
      return false;
    }
    return accessUser;
  }

  logout() {
    /*this.authCasService.logout();*/
  }

  cambiaMatricola() {
    localStorage.removeItem('access_user');
    localStorage.removeItem('isAzienda');
    location.reload();
  }

  isProduzione() {
    return environment.production;
  }
}
